<!-- Anzeige der aktuellen Konfiguration -->
<div class="flex items-center gap-x-3 gap-y-1 py-1 flex-wrap">
  @if (config(); as c) {
    <span class="bm-badge bm-badge-xs" [class]="badgeClass()">{{ c.shipping_type_label }}</span>

    <!-- Versandart + Geschwindigkeit -->
    <span class="text-xs text-base-content/70 inline-flex items-center gap-1">
      @if (shipmentMethodIcon(); as icon) {
        <fa-icon [icon]="icon" />
      }
      <span>{{ shipmentMethodLabel() }}{{ packageSpeedSuffix() }}</span>
    </span>

    <!-- Ziel-Techniker (bei PickPoint/Techniker/Filialversand mit Umbuchung) -->
    @if (c.target_user_name) {
      <span class="text-xs text-base-content/70 inline-flex items-center gap-1">
        <fa-icon [icon]="iconTechnician" />
        <span>{{ c.target_user_name }}</span>
      </span>
    }

    <!-- Versanddatum (wenn explizit gesetzt; sonst operation_date als Fallback). -->
    @if (c.shipping_date) {
      <span class="text-xs text-base-content/70 inline-flex items-center gap-1">
        <fa-icon [icon]="iconDate" />
        <span>{{ c.shipping_date | date:'dd.MM.yyyy' }}</span>
      </span>
    }

    <!-- PM-Code bei PickPoint-Configs -->
    @if (c.pm_code) {
      <span class="bm-badge bm-badge-xs bm-badge-neutral">{{ c.pm_code }}</span>
    }

    <!-- Aktive Config: editierbar. Archivierte Configs werden in der
         operation-requirements-Komponente separat als historische Belege
         angezeigt (Lieferschein-Verweis). -->
    <button class="bm-btn bm-btn-ghost bm-btn-xs ml-auto" (click)="openPopup()">
      <fa-icon [icon]="iconEdit" />
    </button>
    <button class="bm-btn bm-btn-ghost bm-btn-xs text-error" (click)="deleteConfig()">
      <fa-icon [icon]="iconDelete" />
    </button>
  } @else {
    <span class="text-xs opacity-60">{{ emptyLabel }}</span>
    <button class="bm-btn bm-btn-ghost bm-btn-xs" (click)="openPopup()">{{ createButtonLabel }}</button>
  }
</div>

<!-- Popup mit der Form -->
@if (showPopup()) {
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-[1100] p-4"
       (mousedown)="closePopup()">
    <div class="bg-base-100 rounded-lg shadow-xl max-w-[640px] w-full max-h-[90vh] overflow-y-auto"
         (mousedown)="$event.stopPropagation()">
      <hawk-shipping-config-form
        [initialConfig]="config()"
        [context]="context()"
        [ticketStoreId]="ticketStoreId"
        [ticketLat]="ticketLat"
        [ticketLng]="ticketLng"
        [referenceDate]="referenceDate"
        [projectId]="projectId"
        [operationTechnicianId]="operationTechnicianId"
        [heading]="formHeading"
        (save)="onSave($event)"
        (cancel)="closePopup()"
      />
    </div>
  </div>
}
